import "./ActiveIndicator.scss";

const ActiveIndicator = ({ active = false }) => (
  <div className="active-indicator" aria-hidden="true">
    <div className={`active-indicator__dot active-indicator__dot--${active ? "active" : "inactive"}`} />
  </div>
);

export default ActiveIndicator;
